import { Folder } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { frameworkService } from '~/lib/services/frameworkService';
import type { ExtendedChatHistoryItem } from '~/lib/stores/storageStatusStore';
import { type Framework, type Language } from '~/lib/stores/techStackSelection';

interface HistoryItemProps {
  item: ExtendedChatHistoryItem;
  onDelete?: (event: React.UIEvent) => void;
}

export function HistoryItem({ item, onDelete }: HistoryItemProps) {
  const [hovering, setHovering] = useState(false);
  const hoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;

    function mouseEnter() {
      setHovering(true);

      if (timeout) {
        clearTimeout(timeout);
      }
    }

    function mouseLeave() {
      setHovering(false);
    }

    hoverRef.current?.addEventListener('mouseenter', mouseEnter);
    hoverRef.current?.addEventListener('mouseleave', mouseLeave);

    return () => {
      hoverRef.current?.removeEventListener('mouseenter', mouseEnter);
      hoverRef.current?.removeEventListener('mouseleave', mouseLeave);
    };
  }, []);

  return (
    <div
      ref={hoverRef}
      className="group rounded-md bg-[#2a2a2a] hover:bg-[#313131] overflow-hidden px-3 py-2 my-2 transition-all duration-200"
    >
      <a href={`/chat/${item.projectId}/${item.urlId}`} className="flex flex-col w-full relative gap-1">
        <div className="flex justify-between items-center mb-1.5">
          <div className="flex items-center">
            <Folder className="w-3 h-3 mr-1 text-gray-300" />
            <span className="text-[13px] text-gray-100">
              {item.description?.slice(0, 30)}
              {item.description && item.description.length > 30 ? '...' : ''}
            </span>
          </div>

          {/* {hovering ? (
            <div className="flex items-center text-gray-400 hover:text-red-500">
              <Dialog.Trigger asChild>
                <button
                  className="i-ph:trash scale-90"
                  onClick={(event) => {
                    event.preventDefault();
                    onDelete?.(event);
                  }}
                />
              </Dialog.Trigger>
            </div>
          ) : (
            <div className="flex items-center text-gray-400 hover:text-gray-300"></div>
          )} */}
        </div>

        {item.techStack ? (
          <div className="flex justify-between items-center">
            <div className="flex gap-1.5">
              {item.techStack.framework && (
                <span className="text-[10px] bg-[#1e1e1e] text-gray-300 px-2 py-1 rounded-md">
                  {frameworkService.formatFramework(item.techStack.framework as Framework)}
                </span>
              )}
              {item.techStack.language && (
                <span className="text-[10px] bg-[#1e1e1e] text-gray-300 px-2 py-1 rounded-md">
                  {frameworkService.formatLanguage(item.techStack.language as Language)}
                </span>
              )}
            </div>
            {item.isGitRepo && (
              <button
                className="i-ph:github-logo w-3.5 h-3.5 text-gray-400 hover:text-white hover:scale-120 transition-all duration-200 hover:p-1"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  window.open(
                    `https://github.com/${item?.connections?.github?.ownerName}/${item?.connections?.github?.repoName}/tree/${item?.connections?.github?.branch}`,
                    '_blank',
                  );
                }}
              />
            )}
          </div>
        ) : null}
      </a>
    </div>
  );
}
